const realTime = () => import('./realTimePage.vue');

export default [
  {
    path: '/real-time/realtime',
    name: 'realTime',
    component: realTime
  }
];
